<template>
  <div v-if="confirmations && confirmations.length > 0" class="confirmations">
    <div class="ttl">Confirmations</div>
    <div class="list">
      <div class="msg">To select seats, upgrade or check in, please use the following details:</div>
      <div v-for="c in confirmations.filter(c => c.is_flight)" :key="c.id" class="booking">
        <span class="icon">&#x1f3ab;</span>
        <a v-if="c.confirmations && c.confirmations.length" class="airline" target="_blank" :href="bookingUrl(c)">{{ c.confirmations[0].airline || c.confirmations[0].provider }}</a>
        <p v-else class="airline">Unknown</p>
        <span class="route">&nbsp;({{ c.route }})</span>
        <span class="num">{{ confirmationShow(c) }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps(["confirmations"]);

const bookingUrl = c => {
  if (!c.confirmations || !c.confirmations.length) return "#";

  if (c.confirmations[0].booking_url) return c.confirmations[0].booking_url;
  if (c.confirmations[0].airline) return `https://www.google.com/search?q=${c.confirmations[0].airline} booking manage`;
  if (c.confirmations[0].provider) return `https://www.google.com/search?q=${c.confirmations[0].provider} booking manage`;
  return "#";
};

const confirmationShow = c => {
  if (c.confirmations && c.confirmations.length) return `${c.confirmations[0].pnr}`;
  return "N/A";
};
</script>
